import {
  Dialog,
  Typography,
  ButtonSize,
  PrimaryButton,
  ButtonVariant,
  ButtonOption,
  SecondaryButton,
} from '@uni-of-exeter/digital.lib.react.ui.kit';
import './confirmation-modal.css';
export interface ConfirmationModalProps {
  text: {
    title: string;
    body: string;
    confirmButton: string;
    cancelButton: string;
    accessibility: {
      confirmBtnAriaDescription?: string;
      cancelBtnAriaDescription?: string;
      dialogAriaLabel?: string;
    };
  };
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmationModal = ({ text, isOpen, onClose, onConfirm }: ConfirmationModalProps) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="confirmationModal"
      aria-modal="true"
      aria-label={text.accessibility.dialogAriaLabel}
      description={text.body}
      hideIcon={true}
      darkBackdrop={true}
      header={
        <Typography
          variant="h4"
          fontWeight={700}
          lineHeight="150%"
        >
          {text.title}
        </Typography>
      }
      footer={
        <div className="confirmationModalButtons">
          <div className="confirmationModalConfirmButton">
            <PrimaryButton
              tabIndex={0}
              variant={ButtonVariant.Solid}
              size={ButtonSize.Large}
              onClick={() => {
                onConfirm();
                onClose();
              }}
              aria-label={text.confirmButton}
              aria-description={text.accessibility.confirmBtnAriaDescription}
            >
              {text.confirmButton}
            </PrimaryButton>
          </div>
          <div className="confirmationModalCancelButton">
            <SecondaryButton
              tabIndex={0}
              variant={ButtonVariant.Outline}
              size={ButtonSize.Large}
              coloroption={ButtonOption.Primary}
              onClick={onClose}
              aria-label={text.cancelButton}
              aria-description={text.accessibility.cancelBtnAriaDescription}
            >
              {text.cancelButton}
            </SecondaryButton>
          </div>
        </div>
      }
    ></Dialog>
  );
};

export default ConfirmationModal;
